import Type from "./Type";
import {Checkbox, TextField} from "@mui/material";
import isNull from "../../mixin/isNull";

/**
 *
 * @param paginationColumn {PaginationColumn}
 * @param defaultValue
 * @param rowId
 */
export default function ({paginationColumn, defaultValue, row}) {

    const handleChange = async e => {
        if (isNull(paginationColumn.getEditHandler())) {
            console.warn("[PAGINATION] No edit handler function provided");
            return;
        }

        await paginationColumn.getEditHandler()(row, e);
    }

    const handleKeyDown = async e => {
        if (e.key !== "Enter") return;

        if (isNull(paginationColumn.getEditHandler())) {
            console.warn("[PAGINATION] No edit handler function provided");
            return;
        }

        await paginationColumn.getEditHandler()(row, e);
    }

    if (paginationColumn.getType() === Type.BOOLEAN) {
        return (
            <Checkbox defaultChecked={defaultValue} onChange={handleChange}/>
        );
    }

    if (paginationColumn.getType() === Type.NUMBER
        || paginationColumn.getType() === Type.STRING) {
        return (
            <TextField
                fullWidth
                autoFocus
                variant="outlined"
                type={paginationColumn.getType() === Type.NUMBER ? "number" : "text"}
                defaultValue={defaultValue}
                onKeyDown={handleKeyDown}
            />
        )
    }

    return null;
}